import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ImportadorIfoodService} from "../../services/importador-ifood.service";
import {PainelImportacaoProdutosComponent} from "../painel-importacao-produtos/painel-importacao-produtos.component";
import {ArmazenamentoService} from "../../services/armazenamento.service";
import {ModalKendo} from "../../lib/ModalKendo";
import {CanaisVendaFacade} from '../../canais-venda/canais-venda.facade';
import {CanalVendaVM} from '../../canais-venda/canais-venda.models';
declare var moment;

@Component({
  selector: 'app-tela-sincronizar-ifood',
  templateUrl: './tela-sincronizar-ifood.component.html',
  styleUrls: ['./tela-sincronizar-ifood.component.scss'],
  providers: [CanaisVendaFacade]
})
export class TelaSincronizarIfoodComponent  extends ModalKendo implements OnInit {
  @Input() empresa: any;
  @ViewChild('frm', {static: false}) frm: NgForm;
  @ViewChild('painelImportacao', {static: false}) painelImportacao: PainelImportacaoProdutosComponent;
  catalogo: any = {};
  mensagemSucesso: any;
  mensagemErro: any;
  mensagemAviso: any;
  opcoes: any = { link: null, salvoLink: false};
  buscando = false;
  filtro: any;
  buscarProdutos: boolean
  buscouProdutos: boolean;
  tudoSincronizado: boolean;
  sincronizando: boolean;
  sincronizou: boolean;
  KEYLINKLOJA = '#linklojaifood'
  KEYLINKLOJAANOTAI = '#linklojaifood'
  KEYLINKLOJAOLACLICK = '#linklojaOlaclick'
  KEYLINKLOJACARDAPIOWEB = '#linklojaCardapioWeb'
  KEYLINKSISTEMAEXTERNO = '#linkSistemaExterno'
  KEYS_SISTEMA_EXTERNO: Record<string, string> = {
    ifood:       '#linkSistemaExterno_ifood',
    anotaai:     '#linkSistemaExterno_anotaai',
    olaclick:    '#linkSistemaExterno_olaclick',
    cardapioweb: '#linkSistemaExterno_cardapioweb',
    cardapioai: '#linkSistemaExterno_cardapioai',
    goomer: '#linkSistemaExterno_goomer',
    uairango:    '#linkSistemaExterno_uairango',
    instadelivery: '#linkSistemaExterno_instadelivery',
    menudino:    '#linkSistemaExterno_menudino',
    deliverydireto: '#linkSistemaExterno_deliverydireto',
    takeat: '#linkSistemaExterno_takeat',
    yooga: '#linkSistemaExterno_yooga',
    pedirdelivery: '#linkSistemaExterno_pedirdelivery',
    pecaqui: '#linkSistemaExterno_pecaqui',
    livemenu: '#linkSistemaExterno_livemenu',
    whatsmenu: '#linkSistemaExterno_whatsmenu',
    brendi: '#linkSistemaExterno_brendi',
    meucardapio: '#linkSistemaExterno_meucardapio',
  };
  empresaInfo: any;
  sistemaExterno = false;
  anotaAi = false;
  olaclick = false;
  cardapioWeb = false;
  cardapioAi = false;
  goomer = false;
  uaiRango = false;
  instaDelivery = false;
  menuDino = false;
  deliveryDireto = false;
  takeat = false;
  yooga = false;
  pedirDelivery = false;
  pecaqui = false;
  liveMenu = false;
  whatsMenu = false;
  brendi = false;
  meuCardapio = false;
  ifoodOficial = false;
  food99Oficial = false;
  PLATAFORMAS = [
    { id: 'anotaai',     nome: 'Anota Ai',     logo: 'assets/icons/logo-anotaai.png',     placeholder: 'nome-da-sua-loja', prefixo: 'pedido.anota.ai/loja/' },
    { id: 'olaclick',    nome: 'OlaClick',     logo: 'assets/icons/logo-olaclick.png',    placeholder: 'nome-da-sua-loja', prefixo: '', sufixo: '.ola.click' },
    { id: 'cardapioweb', nome: 'Cardápio Web', logo: 'assets/icons/logo-cardapioweb.png', placeholder: 'nome-do-cardapio', prefixo: 'app.cardapioweb.com/' },
    { id: 'cardapioai', nome: 'Cardapio.ai', logo: 'https://cardapio.ai/favicon.ico', placeholder: 'nome-do-cardapio', prefixo: 'cardapio.ai/' },
    { id: 'goomer', nome: 'Goomer', logo: 'assets/icons/logo-goomer.svg', placeholder: 'Cole o link da sua loja no Goomer', prefixo: '' },
    { id: 'uairango',    nome: 'UaiRango',     logo: 'https://www.uairango.com/favicon.ico', placeholder: 'nome-da-sua-loja', prefixo: 'uairango.com/' },
    { id: 'instadelivery', nome: 'InstaDelivery', logo: 'assets/icons/logo-instadelivery.jpg', placeholder: 'nome-da-sua-loja', prefixo: 'instadelivery.com.br/' },
    { id: 'menudino',    nome: 'MenuDino',     logo: 'assets/icons/logo-menudino.png', placeholder: 'nome-da-sua-loja', prefixo: '', sufixo: '.menudino.com.br' },
    { id: 'deliverydireto', nome: 'Delivery Direto', logo: 'https://deliverydireto.com.br/favicon.ico', placeholder: 'marca/nome-da-loja', prefixo: 'deliverydireto.com.br/' },
    { id: 'takeat', nome: 'Takeat', logo: 'https://pedido.takeat.app/favicon.ico', placeholder: 'nome-da-sua-loja', prefixo: 'pedido.takeat.app/' },
    { id: 'yooga', nome: 'Yooga', logo: 'assets/images/plataformas/yooga.png', placeholder: 'nome-da-sua-loja', prefixo: 'delivery.yooga.app/' },
    { id: 'pedirdelivery', nome: 'Pedir Delivery', logo: 'https://multipedidos.com.br/favicon.png', placeholder: 'nome-da-sua-loja', prefixo: 'pedir.delivery/app/' },
    { id: 'pecaqui', nome: 'Pecaqui', logo: 'https://pecaqui.online/img/iconheader.png', placeholder: 'nome-da-sua-loja', prefixo: 'pecaqui.online/' },
    { id: 'livemenu', nome: 'Live Menu', logo: 'https://framerusercontent.com/images/pFV4wn9lFBLvchVwS1hwdLQFwEU.png', placeholder: 'Cole o link do cardápio no Live Menu', prefixo: '' },
    { id: 'whatsmenu', nome: 'WhatsMenu', logo: 'assets/images/plataformas/whatsmenu.png', placeholder: 'dominio-da-sua-loja.com.br', prefixo: '' },
    { id: 'brendi', nome: 'Brendi', logo: 'assets/images/plataformas/brendi.webp', placeholder: 'nome-da-sua-loja', prefixo: 'pedido.brendi.com.br/' },
    { id: 'meucardapio', nome: 'MeuCardápio.ai', logo: 'https://meucardapio.ai/favicon.ico', placeholder: 'nome-da-sua-loja', prefixo: '', sufixo: '.meucardapio.ai' },
  ];
  PLATAFORMA_IFOOD = { id: 'ifood', nome: 'iFood', logo: 'assets/icons/logo-ifood.png', placeholder: 'nome-da-sua-loja', prefixo: 'ifood.com.br/delivery/' };
  plataformaDetectada: any = null;
  plataformaSelecionada: any = null;
  integracoesIfood: any[] = [];
  integracoesFood99: any[] = [];
  canaisVenda: CanalVendaVM[] = [];
  canalReducao: CanalVendaVM | null = null;
  carregandoCanais = false;
  private canaisConsultados = false;
  private reducaoAutomatica: number | null = null;
  catalogosIfood: any[] = [];
  carregandoCatalogos = false;
  carregandoAdicionais = false;
  carregamentoAdicionais: any = {
    totalProdutos: 0,
    totalPaginas: 0,
    paginaAtual: 0,
    totalProcessados: 0,
    finalizado: false
  };
  statusCarregamentoAdicionais = '';
  // Depois disso desiste dos adicionais e libera a importação dos produtos sem eles (antes tentava para sempre e travava a tela).
  readonly MAX_TENTATIVAS_PAGINA_ADICIONAIS = 3;
  pularAdicionais = false;
  produtosSemAdicionais = 0;
  constructor( private importador:  ImportadorIfoodService,
              private armazenamentoService: ArmazenamentoService,
              private canaisVendaFacade: CanaisVendaFacade) {
    super()

  }

  ngOnInit(): void {
   this.buscarProdutos = true

    if(this.food99Oficial || this.ifoodOficial || this.usaFluxoIfoodAntigo())
      this.carregueCanaisVenda();

    if(this.food99Oficial){
      this.integracoesFood99 = (this.empresa && this.empresa.integracoes99Food)
        ? this.empresa.integracoes99Food.filter((item: any) => !item.desativado)
        : [];

      if(this.integracoesFood99.length === 1)
        this.opcoes.idIntegracaoFood99 = this.integracoesFood99[0].id;

      this.atualizeReducaoDoCanal();

      return;
    }

    if(this.ifoodOficial){
      this.integracoesIfood = (this.empresa && this.empresa.integracoesIfood)
        ? this.empresa.integracoesIfood.filter((item: any) => !item.desativado)
        : [];

      if(this.integracoesIfood.length === 1){
        this.opcoes.idLojaIfood = this.integracoesIfood[0].idLoja;
        this.onMudouIntegracaoIfood();
      }

      this.atualizeReducaoDoCanal();

      return;
    }

    if(this.sistemaExterno){
      // Link carregado por plataforma ao selecionar o card
      return;
    }

    if(this.cardapioWeb){
      let linkCardapioWeb = this.armazenamentoService.carregue(this.KEYLINKLOJACARDAPIOWEB, false)
      if(linkCardapioWeb) this.opcoes.link = this.extraiaNomeLoja(linkCardapioWeb, this.PLATAFORMAS.find(p => p.id === 'cardapioweb'))
    } else if(this.olaclick){
      let linkOlaclick = this.armazenamentoService.carregue(this.KEYLINKLOJAOLACLICK, false)
      if(linkOlaclick) this.opcoes.link = this.extraiaNomeLoja(linkOlaclick, this.PLATAFORMAS.find(p => p.id === 'olaclick'))
    } else if(!this.anotaAi){
      if(this.catalogo && this.catalogo.lojaIfood){
        this.opcoes.link = this.extraiaNomeLoja(this.catalogo.lojaIfood, this.PLATAFORMA_IFOOD);
      } else {
        let linkIfood = this.armazenamentoService.carregue(this.KEYLINKLOJA, false)

        if(linkIfood)
          this.opcoes.link = this.extraiaNomeLoja(linkIfood, this.PLATAFORMA_IFOOD);

      }
    } else {
      let linkAnotai = this.armazenamentoService.carregue(this.KEYLINKLOJAANOTAI, false)

      if(linkAnotai) this.opcoes.link = this.extraiaNomeLoja(linkAnotai, this.PLATAFORMAS.find(p => p.id === 'anotaai'))
    }
    this.atualizeReducaoDoCanal();
  }

  private async carregueCanaisVenda(): Promise<void> {
    this.carregandoCanais = true;
    try {
      this.canaisVenda = await this.canaisVendaFacade.listeCanais();
      this.atualizeReducaoDoCanal();
    } catch(erro) {
      this.mensagemAviso = 'Não foi possível consultar os canais de venda para calcular a redução automaticamente.';
    } finally {
      this.carregandoCanais = false;
      this.canaisConsultados = true;
    }
  }

  onMudouIntegracaoFood99(integracaoId: number): void {
    this.opcoes.idIntegracaoFood99 = integracaoId;
    this.atualizeReducaoDoCanal();
  }

  onMudouCatalogoIfood(catalogoId: string): void {
    this.opcoes.idCatalogoIfood = catalogoId;
    this.atualizeReducaoDoCanal();
  }

  private verifiqueCanalDoLink(): void {
    if(!this.usaFluxoIfoodAntigo()) {
      this.atualizeReducaoDoCanal();
      return;
    }
    if(!this.canaisConsultados && !this.carregandoCanais)
      this.carregueCanaisVenda();
    else
      this.atualizeReducaoDoCanal();
  }

  atualizeReducaoDoCanal(): void {
    const catalogoId = Number(this.catalogo?.id || this.empresa?.catalogo?.id);
    const canais = this.canaisVenda.filter(canal => {
      if(!canal.ativo || !Number.isFinite(Number(canal.percentualPrecoPadrao)) ||
          canal.percentualPrecoPadrao == null || Number(canal.percentualPrecoPadrao) <= 0 ||
          Number(canal.catalogoId) !== catalogoId) return false;
      if(this.food99Oficial)
        return canal.plataforma === 'FOOD99' && Number(canal.integracaoId) === Number(this.opcoes.idIntegracaoFood99);
      if(this.ifoodOficial)
        return canal.plataforma === 'IFOOD' &&
          String(canal.merchantId) === String(this.opcoes.idLojaIfood) &&
          String(canal.catalogoExternoId) === String(this.opcoes.idCatalogoIfood);
      if(this.usaFluxoIfoodAntigo() && this.opcoes.link)
        return canal.plataforma === 'IFOOD' &&
          String(canal.merchantId) === String(this.importador.obtenhaIdDaLoja(this.obtenheLinkCompleto()));
      return false;
    });
    const canal = canais.length === 1 ? canais[0] : null;
    if(this.canalReducao && this.opcoes.reducao === this.reducaoAutomatica)
      this.opcoes.reducao = null;
    this.canalReducao = canal;
    this.reducaoAutomatica = canal ? 100 * Number(canal.percentualPrecoPadrao) /
      (100 + Number(canal.percentualPrecoPadrao)) : null;
    if(canal) {
      this.opcoes.reducao = this.reducaoAutomatica;
      this.opcoes.sincronizarPrecos = true;
    }
  }

  aoAlterarReducao(): void {
    this.canalReducao = null;
    this.reducaoAutomatica = null;
  }

  obtenhaNomeFonteImportacao() {
    if(this.food99Oficial) return '99Food';
    if(this.plataformaDetectada) return this.plataformaDetectada.nome;
    if(this.cardapioWeb) return 'Cardápio Web';
    if(this.cardapioAi) return 'Cardapio.ai';
    if(this.goomer) return 'Goomer';
    if(this.uaiRango) return 'UaiRango';
    if(this.deliveryDireto) return 'Delivery Direto';
    if(this.takeat) return 'Takeat';
    if(this.yooga) return 'Yooga';
    if(this.pedirDelivery) return 'Pedir Delivery';
    if(this.pecaqui) return 'Pecaqui';
    if(this.liveMenu) return 'Live Menu';
    if(this.whatsMenu) return 'WhatsMenu';
    if(this.brendi) return 'Brendi';
    if(this.meuCardapio) return 'MeuCardápio.ai';
    if(this.olaclick) return 'Olaclick';
    if(this.anotaAi) return 'Anota Ai';

    return 'Ifood';
  }

  detectePlataforma(url: string): any {
    if(!url) return null;
    const urlLower = url.toLowerCase().trim();

    if(urlLower.includes('.ola.click') || urlLower.includes('olaclick'))
      return this.PLATAFORMAS.find(p => p.id === 'olaclick');

    if(urlLower.includes('anota.ai') || urlLower.includes('anotaai'))
      return this.PLATAFORMAS.find(p => p.id === 'anotaai');

    if(urlLower.includes('meucardapio.ai') || urlLower.includes('promokit.com.br'))
      return this.PLATAFORMAS.find(p => p.id === 'meucardapio');

    if(urlLower.includes('cardapio.ai'))
      return this.PLATAFORMAS.find(p => p.id === 'cardapioai');

    if(urlLower.includes('goomer'))
      return this.PLATAFORMAS.find(p => p.id === 'goomer');

    if(urlLower.includes('cardapioweb'))
      return this.PLATAFORMAS.find(p => p.id === 'cardapioweb');

    if(urlLower.includes('uairango.com') || urlLower.includes('uairango'))
      return this.PLATAFORMAS.find(p => p.id === 'uairango');

    if(urlLower.includes('instadelivery'))
      return this.PLATAFORMAS.find(p => p.id === 'instadelivery');

    if(urlLower.includes('menudino'))
      return this.PLATAFORMAS.find(p => p.id === 'menudino');

    if(urlLower.includes('deliverydireto'))
      return this.PLATAFORMAS.find(p => p.id === 'deliverydireto');

    if(urlLower.includes('takeat'))
      return this.PLATAFORMAS.find(p => p.id === 'takeat');

    if(urlLower.includes('livemenu.app'))
      return this.PLATAFORMAS.find(p => p.id === 'livemenu');

    if(urlLower.includes('pecaqui.online'))
      return this.PLATAFORMAS.find(p => p.id === 'pecaqui');

    if(urlLower.includes('pedir.delivery'))
      return this.PLATAFORMAS.find(p => p.id === 'pedirdelivery');
    if(urlLower.includes('yooga'))
      return this.PLATAFORMAS.find(p => p.id === 'yooga');

    if(urlLower.includes('whatsmenu'))
      return this.PLATAFORMAS.find(p => p.id === 'whatsmenu');

    if(urlLower.includes('brendi'))
      return this.PLATAFORMAS.find(p => p.id === 'brendi');

    if(urlLower.includes('ifood'))
      return this.PLATAFORMA_IFOOD;

    return null;
  }

  selecionePlataforma(plataforma: any) {
    if(this.plataformaSelecionada?.id === plataforma.id) return;
    this.plataformaSelecionada = plataforma;
    this.plataformaDetectada = plataforma;
    this.anotaAi = plataforma.id === 'anotaai';
    this.olaclick = plataforma.id === 'olaclick';
    this.cardapioWeb = plataforma.id === 'cardapioweb';
    this.cardapioAi = plataforma.id === 'cardapioai';
    this.goomer = plataforma.id === 'goomer';
    this.uaiRango = plataforma.id === 'uairango';
    this.instaDelivery = plataforma.id === 'instadelivery';
    this.menuDino = plataforma.id === 'menudino';
    this.deliveryDireto = plataforma.id === 'deliverydireto';
    this.takeat = plataforma.id === 'takeat';
    this.yooga = plataforma.id === 'yooga';
    this.pedirDelivery = plataforma.id === 'pedirdelivery';
    this.pecaqui = plataforma.id === 'pecaqui';
    this.liveMenu = plataforma.id === 'livemenu';
    this.whatsMenu = plataforma.id === 'whatsmenu';
    this.brendi = plataforma.id === 'brendi';
    this.meuCardapio = plataforma.id === 'meucardapio';
    const linkSalvo = this.armazenamentoService.carregue(this.KEYS_SISTEMA_EXTERNO[plataforma.id], false);
    this.opcoes.link = linkSalvo ? this.extraiaNomeLoja(linkSalvo, plataforma) : null;
    delete this.mensagemErro;
    this.verifiqueCanalDoLink();
  }

  onUrlChanged() {
    if(!this.sistemaExterno) return;
    const detectada = this.detectePlataforma(this.opcoes.link);
    if(detectada && detectada.id !== this.plataformaSelecionada?.id) {
      this.plataformaSelecionada = detectada;
      this.plataformaDetectada = detectada;
      this.anotaAi = detectada.id === 'anotaai';
      this.olaclick = detectada.id === 'olaclick';
      this.cardapioWeb = detectada.id === 'cardapioweb';
      this.cardapioAi = detectada.id === 'cardapioai';
      this.goomer = detectada.id === 'goomer';
      this.uaiRango = detectada.id === 'uairango';
      this.instaDelivery = detectada.id === 'instadelivery';
      this.menuDino = detectada.id === 'menudino';
      this.deliveryDireto = detectada.id === 'deliverydireto';
      this.takeat = detectada.id === 'takeat';
      this.yooga = detectada.id === 'yooga';
      this.pedirDelivery = detectada.id === 'pedirdelivery';
      this.pecaqui = detectada.id === 'pecaqui';
      this.liveMenu = detectada.id === 'livemenu';
      this.whatsMenu = detectada.id === 'whatsmenu';
      this.brendi = detectada.id === 'brendi';
      this.meuCardapio = detectada.id === 'meucardapio';
    }
    this.verifiqueCanalDoLink();
  }

  extraiaNomeLoja(link: string, plataforma: any): string {
    if(!link) return link;
    if(plataforma?.id === 'livemenu') return link.trim();
    if(plataforma?.id === 'pedirdelivery' || plataforma?.id === 'pecaqui') return link.trim();
    if(plataforma?.id === 'goomer') return link.trim();
    // Remove protocolo e query string
    let limpo = link.replace(/https?:\/\/(www\.)?/, '').split('?')[0].replace(/\/+$/, '').trim();
    if(plataforma?.sufixo) {
      // Formato subdomínio: nome.menudino.com → nome
      return limpo.split('.')[0];
    }
    // Formato path: dominio.com/caminho/slug → slug (último segmento)
    const partes = limpo.split('/');
    if(plataforma?.id === 'deliverydireto' && partes.length >= 3)
      return partes.slice(-2).join('/');
    if(plataforma?.id === 'yooga' && partes.length >= 2)
      return partes[1];

    return partes[partes.length - 1].trim();
  }

  obtenheLinkCompleto(): string {
    const nome = this.opcoes.link?.trim();
    if(!nome || !this.plataformaSelecionada) return nome;
    const p = this.plataformaSelecionada;
    if(nome.includes('://') || /\.[a-z]{2,}/i.test(nome)) return nome;
    if(p.sufixo) return `https://${nome}${p.sufixo}`;
    if(p.prefixo) return `https://${p.prefixo}${nome}`;
    return nome;
  }

  linkCopiado = false;

  copiarLink() {
    const link = this.obtenheLinkCompleto();
    if(link) {
      navigator.clipboard.writeText(link);
      this.linkCopiado = true;
      setTimeout(() => this.linkCopiado = false, 2000);
    }
  }

  onPasteLink(event: ClipboardEvent) {
    const texto = event.clipboardData?.getData('text')?.trim();
    if(!texto) return;
    // Detecta plataforma pelo link colado
    const detectada = this.detectePlataforma(texto);
    if(detectada) {
      event.preventDefault();
      if(detectada.id !== this.plataformaSelecionada?.id) {
        this.selecionePlataforma(detectada);
      }
      this.opcoes.link = this.extraiaNomeLoja(texto, detectada);
      this.verifiqueCanalDoLink();
    }
  }

  usaFluxoIfoodAntigo() {
    if(this.sistemaExterno) return this.plataformaDetectada?.id === 'ifood';
    return !this.anotaAi && !this.ifoodOficial   && !this.food99Oficial && !this.olaclick
        && !this.cardapioWeb && !this.cardapioAi && !this.goomer && !this.uaiRango && !this.instaDelivery && !this.menuDino && !this.deliveryDireto && !this.takeat && !this.yooga && !this.pedirDelivery && !this.pecaqui && !this.liveMenu && !this.whatsMenu && !this.brendi && !this.meuCardapio;
  }

  fecheMensagemErro() {
    delete this.mensagemErro;
  }

  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }

  feche() {
    this.fecheModal(this.painelImportacao.importou)
  }

   async onBusqueProdutos() {
    if(this.buscando || this.carregandoCanais) return;

    delete this.mensagemErro;
    delete this.mensagemSucesso;
    delete this.mensagemAviso;
    delete this.tudoSincronizado;
    this.statusCarregamentoAdicionais = '';
    this.pularAdicionais = false;
    this.produtosSemAdicionais = 0;

    this.buscando = true;

    let resposta: any, keyBusca: string;

    if(this.sistemaExterno){
      if(!this.plataformaSelecionada){
        this.buscando = false;
        this.mensagemErro = 'Selecione uma plataforma antes de buscar.';
        return;
      }
      keyBusca = this.KEYS_SISTEMA_EXTERNO[this.plataformaSelecionada.id];
    }

    if(this.food99Oficial){
      if(!this.opcoes.idIntegracaoFood99){
        this.buscando = false;
        this.mensagemErro = 'Selecione uma integração 99Food.';
        return;
      }

      resposta = await this.importador.listeNovosProdutosFood99(
        this.opcoes.idIntegracaoFood99,
        this.opcoes.reducao,
        this.opcoes.sincronizarPrecos,
        this.opcoes.sincronizarImagens
      ).catch(erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.meuCardapio){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.meucardapio;
      resposta = await this.importador.listeNovosProdutosMeuCardapio(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.cardapioWeb){
      if(!keyBusca) keyBusca = this.KEYLINKLOJACARDAPIOWEB;
      resposta = await this.importador.listeNovosProdutosCardapioWeb(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.cardapioAi){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.cardapioai;
      resposta = await this.importador.listeNovosProdutosCardapioAi(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.goomer){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.goomer;
      resposta = await this.importador.listeNovosProdutosGoomer(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.uaiRango){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.uairango;
      resposta = await this.importador.listeNovosProdutosUaiRango(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.instaDelivery){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.instadelivery;
      resposta = await this.importador.listeNovosProdutosInstaDelivery(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.menuDino){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.menudino;
      resposta = await this.importador.listeNovosProdutosMenuDino(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.deliveryDireto){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.deliverydireto;
      resposta = await this.importador.listeNovosProdutosDeliveryDireto(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.takeat){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.takeat;
      resposta = await this.importador.listeNovosProdutosTakeat(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.yooga){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.yooga;
      resposta = await this.importador.listeNovosProdutosYooga(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.pedirDelivery){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.pedirdelivery;
      resposta = await this.importador.listeNovosProdutosPedirDelivery(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.pecaqui){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.pecaqui;
      resposta = await this.importador.listeNovosProdutosPecaqui(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.liveMenu){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.livemenu;
      resposta = await this.importador.listeNovosProdutosLiveMenu(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.whatsMenu){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.whatsmenu;
      resposta = await this.importador.listeNovosProdutosWhatsMenu(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.brendi){
      if(!keyBusca) keyBusca = this.KEYS_SISTEMA_EXTERNO.brendi;
      resposta = await this.importador.listeNovosProdutosBrendi(this.obtenheLinkCompleto(), this.opcoes.reducao,
        this.opcoes.sincronizarPrecos, this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.olaclick){
      if(!keyBusca) keyBusca = this.KEYLINKLOJAOLACLICK;
      resposta = await this.importador.listeNovosProdutosOlaclick(this.obtenheLinkCompleto(), this.opcoes.reducao, this.opcoes.sincronizarPrecos,
        this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else if(this.anotaAi){
      if(!keyBusca) keyBusca = this.KEYLINKLOJAANOTAI;
      resposta = await this.importador.listeNovosProdutosAnotaAi(this.obtenheLinkCompleto(), this.opcoes.reducao, this.opcoes.sincronizarPrecos,
        this.opcoes.sincronizarImagens).catch( erro => {
        this.buscando = false;
        this.mensagemErro = erro;
      });
    } else {
      if(this.ifoodOficial){
        if(!this.opcoes.idLojaIfood || !this.opcoes.idCatalogoIfood){
          this.buscando = false;
          this.mensagemErro = 'Selecione a integração iFood e o catálogo oficial.';
          return;
        }

        resposta = await this.importador.listeNovosProdutosIfoodOficial(this.opcoes.idLojaIfood, this.opcoes.reducao,
          this.opcoes.sincronizarPrecos,
          this.opcoes.sincronizarImagens, this.opcoes.idCatalogoIfood).catch( erro => {
          this.buscando = false;
          this.mensagemErro = erro;
        });
      } else {
        if(!keyBusca) keyBusca = this.KEYLINKLOJA;
        resposta = await this.importador.listeNovosProdutosIfood(this.obtenheLinkCompleto(), this.opcoes.reducao, this.opcoes.sincronizarPrecos,
          this.opcoes.sincronizarImagens).catch( erro => {
          this.buscando = false;
          this.mensagemErro = erro;
        });
      }
    }

    if(resposta){
      this.buscouProdutos = true;
      this.empresaInfo   = resposta.empresaInfo;
      if(Array.isArray(resposta.avisos) && resposta.avisos.length)
        this.mensagemAviso = resposta.avisos.join(' ');
      if(resposta.novosProdutos.length || resposta.produtosAtualizar.length){
        this.buscarProdutos = false;
        this.painelImportacao.setProdutosSincronizar(resposta.novosProdutos, resposta.produtosAtualizar, [],
          resposta.categorias, this.ifoodOficial ? {
            merchantId: this.opcoes.idLojaIfood, catalogoExternoId: this.opcoes.idCatalogoIfood
          } : null)

        if(this.usaFluxoIfoodAntigo()){
          await this.carregueAdicionaisIfood(resposta.novosProdutos, resposta.produtosAtualizar);
        }
      } else {
        this.tudoSincronizado = true;
      }

      this.buscando = false;
      if(keyBusca)
        this.armazenamentoService.salveSemExpirar(keyBusca, this.obtenheLinkCompleto())
    }
  }

  onFilter(texto: any){

  }

  obtenhaFormatoPercentual(){
    return this.canalReducao ? '0.0000"%"' : '0"%"';
  }

  sincronizarTodos() {

  }

  shakePlataforma = false;
  shakeLink = false;
  erroValidacao = '';

  validarEBuscar() {
    if(this.carregandoCanais) return;
    this.erroValidacao = '';
    this.shakePlataforma = false;
    this.shakeLink = false;

    if(this.sistemaExterno && !this.plataformaSelecionada) {
      this.erroValidacao = 'Selecione uma plataforma';
      this.shakePlataforma = true;
      setTimeout(() => this.shakePlataforma = false, 500);
      return;
    }

    if(!this.ifoodOficial && !this.food99Oficial && !this.opcoes.link?.trim()) {
      this.erroValidacao = 'Informe o link da sua loja';
      this.shakeLink = true;
      setTimeout(() => this.shakeLink = false, 500);
      return;
    }

    this.submitFormBusca();
  }

  submitFormBusca() {
    this.frm.ngSubmit.emit()
  }

  importouProdutoDoIfood($event: any) {
    if(!this.opcoes.salvoLink && this.usaFluxoIfoodAntigo()){
      this.importador.salveLinkIfod(this.obtenheLinkCompleto()).then(() => {
        this.opcoes.salvoLink = true;
      });
    }
  }

  private async carregueAdicionaisIfood(novosProdutos: any[], produtosAtualizar: any[]) {
    const tamanhoPagina = 20;
    let todosProdutos = [...(novosProdutos || []), ...(produtosAtualizar || [])];
    let produtosComNeedChoices = todosProdutos.filter((produto: any) => produto && produto.needChoices && produto.idIfood);
    let idsUnicos = Array.from(new Set(produtosComNeedChoices.map((produto: any) => String(produto.idIfood))));

    if(!idsUnicos.length){
      this.carregandoAdicionais = false;
      this.carregamentoAdicionais = {
        totalProdutos: 0,
        totalPaginas: 0,
        paginaAtual: 0,
        totalProcessados: 0,
        finalizado: true
      };
      this.atualizeIndicadoresAdicionais();
      return;
    }

    this.carregandoAdicionais = true;
    this.statusCarregamentoAdicionais = 'Buscando adicionais para importar...';
    this.carregamentoAdicionais = {
      totalProdutos: idsUnicos.length,
      totalPaginas: Math.ceil(idsUnicos.length / tamanhoPagina),
      paginaAtual: 0,
      totalProcessados: 0,
      finalizado: false
    };

    let desistiu = false;

    for(let i = 0; i < idsUnicos.length && !desistiu; i += tamanhoPagina){
      let idsPagina = idsUnicos.slice(i, i + tamanhoPagina);
      this.carregamentoAdicionais.paginaAtual = Math.floor(i / tamanhoPagina) + 1;

      let carregouPagina = false;
      let tentativas = 0;
      while(!carregouPagina){
        if(this.pularAdicionais){
          desistiu = true;
          break;
        }

        let resposta: any
        tentativas++;

        if(this.ifoodOficial){
          resposta =  await  this.importador.listeAdicionaisIfoodOficial(
            this.opcoes.idLojaIfood,
            idsPagina,
            this.opcoes.reducao,
            this.opcoes.idCatalogoIfood
          )
            .catch((erro: any) => {
              return this.deuErro(erro);
            });
        } else {
          resposta =  await  this.importador.listeAdicionaisProdutosIfood(this.obtenheLinkCompleto(), idsPagina, this.opcoes.reducao)
            .catch((erro: any) => {
              return this.deuErro(erro);
            });
        }

        if(!resposta){
          if(tentativas >= this.MAX_TENTATIVAS_PAGINA_ADICIONAIS){
            desistiu = true;
            break;
          }
          await this.sleep(5000);
          continue;
        }

        if(resposta && resposta.produtos){
          resposta.produtos.forEach((produtoComAdicional: any) => {
            let produto = todosProdutos.find((item: any) => String(item.idIfood) === String(produtoComAdicional.idIfood));
            if(produto)
              produto.camposAdicionais = produtoComAdicional.camposAdicionais || [];
          })
        }

        // O servidor desistiu a pedido do usuário e devolveu só o que já tinha buscado.
        if(resposta && resposta.cancelado){
          this.pularAdicionais = true;
          this.carregamentoAdicionais.totalProcessados += (resposta.produtos || []).length;
          desistiu = true;
          break;
        }

        this.statusCarregamentoAdicionais = 'Buscando adicionais para importar...';
        carregouPagina = true;
      }

      if(desistiu) break;

      this.carregamentoAdicionais.totalProcessados += idsPagina.length;
      this.atualizeIndicadoresAdicionais();

      let naoEhUltimaPagina = (i + tamanhoPagina) < idsUnicos.length;
      if(naoEhUltimaPagina && !this.pularAdicionais)
        await this.sleep(8000);
    }

    if(desistiu){
      this.produtosSemAdicionais = idsUnicos.length - this.carregamentoAdicionais.totalProcessados;
      this.mensagemErro = this.pularAdicionais
        ? `Os adicionais de ${this.produtosSemAdicionais} produto(s) não foram carregados. ` +
          `Os produtos serão importados sem adicionais; você pode cadastrá-los depois ou buscar novamente.`
        : `Não foi possível carregar os adicionais de ${this.produtosSemAdicionais} produto(s): o iFood não respondeu. ` +
          `Você pode importar os produtos sem adicionais agora e cadastrá-los depois, ou tentar buscar novamente mais tarde.`;
    }

    this.carregandoAdicionais = false;
    this.carregamentoAdicionais.finalizado = true;
    this.statusCarregamentoAdicionais = '';
    this.atualizeIndicadoresAdicionais();
  }

  importarSemAdicionais() {
    this.pularAdicionais = true;
    this.statusCarregamentoAdicionais = 'Liberando a importação sem adicionais...';

    // Aborta a busca em andamento no servidor; sem isso a chamada pendente só voltaria ao fim da página.
    if(!this.ifoodOficial)
      this.importador.cancelarAdicionaisProdutosIfood(this.obtenheLinkCompleto()).catch((erro: any) => {
        console.error('Falha ao cancelar a busca de adicionais no servidor:', erro);
      });
  }

  private deuErro(erro: any) {
    let detalhe = erro && erro.message ? erro.message : erro;
    console.error('Falha ao carregar adicionais do iFood:', detalhe);
    this.statusCarregamentoAdicionais =
      `O iFood não respondeu na página ${this.carregamentoAdicionais.paginaAtual}/${this.carregamentoAdicionais.totalPaginas}. ` +
      `Tentando novamente em instantes (até ${this.MAX_TENTATIVAS_PAGINA_ADICIONAIS} vezes). ` +
      `Se preferir, importe os produtos sem adicionais.`;
    return null;
  }

  private atualizeIndicadoresAdicionais() {
    if(!this.painelImportacao || !this.painelImportacao.produtosSincronizarPorCategoria) return;

    this.painelImportacao.produtosSincronizarPorCategoria.forEach((categoria: any) => {
      categoria.produtos.forEach((produto: any) => {
        if(produto.sincronizar){
          const campos = produto.camposAdicionais || [];
          produto.qtdeAdicionaisNovos = campos.filter((adicional: any) => !adicional.id).length;
          produto.qtdeAdicionaisAtualizar = campos.filter((adicional: any) => adicional.id != null).length;
        }
      })
    })
  }

  private sleep(ms: number){
    return new Promise((resolve: any) => setTimeout(resolve, ms));
  }

  obtenhaPercentualCarregamentoAdicionais(){
    if(!this.carregamentoAdicionais || !this.carregamentoAdicionais.totalProdutos) return 0;
    return Math.round((this.carregamentoAdicionais.totalProcessados / this.carregamentoAdicionais.totalProdutos) * 100);
  }

  async onMudouIntegracaoIfood() {
    this.opcoes.idCatalogoIfood = null;
    this.catalogosIfood = [];
    this.atualizeReducaoDoCanal();
    if(!this.opcoes.idLojaIfood) return;

    this.carregandoCatalogos = true;
    delete this.mensagemErro;

    let catalogos: any[] = await this.importador.listeCatalogosIfoodOficial(this.opcoes.idLojaIfood).catch((erro) => {
      this.mensagemErro = erro;
      this.carregandoCatalogos = false;
    });

    if(catalogos){
      this.catalogosIfood = catalogos.map((catalogo: any) => {
        let descricao = catalogo.name  || catalogo.type || catalogo.context || catalogo.id;

        if(catalogo.modifiedAt)
            descricao = ` ${descricao} - Ultima alteraçao: ${moment(new Date(catalogo.modifiedAt)).format('DD/MMM/YY HH:mm')}`

        return { id: catalogo.catalogId, descricao: descricao};
      });

      if(this.catalogosIfood.length === 1)
        this.opcoes.idCatalogoIfood = this.catalogosIfood[0].id;

      this.atualizeReducaoDoCanal();
    }

    this.carregandoCatalogos = false;
  }
}
